import React, { Component } from 'react';
import { Table, message } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import Filter from './Filter';
import moment from "moment";

const monthFormat = 'YYYY-MM';

class Staffing extends Component {
    state = {
        sortParams: {},
        searchParams: {
            startDate: moment().add(1, 'months').format(monthFormat),
            endDate: moment().add(12, 'months').format(monthFormat),
        },
        invSortParams: {},
        invSearchParams: {},
        data: [],
        pagination: {
            pageSize: 3,
            current: 1,
        }, 
        loading: false,
        invLoading: false,
        expandedRowKeys: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { startDate, endDate } = searchParams;
        if (!startDate) {
            message.warning('请选择筛选开始时间');
            return;
        } else if (!endDate) {
            message.warning('请选择筛选结束时间');
            return;
        }
        this.setState({
            loading: true,
            expandedRowKeys: [],
         });
        const options = {
            method: 'POST',
            url: API_URL.hospital.querySsuMemberArrangeList,
            data: {
                ...sortParams,
                ...searchParams,
                offset: pagination.current,
                limit: pagination.pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const pagination = { ...this.state.pagination };
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    loadInvData = () => {
        const { searchParams, invSortParams, invSearchParams } = this.state;
        this.setState({
            invLoading: true,
        });
        const options = {
            method: 'POST',
            url: API_URL.hospital.querySsuMemberArrangeInfo,
            data: {
                ...searchParams,
                ...invSearchParams,
                ...invSortParams,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    [`invList${invSearchParams.key}`]: res.ssuMemberList,
                    invLoading: false,
                });
            },
            errorResult: () => {
                this.setState({ invLoading: false });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { data, expandedRowKeys } = this.state;
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 120,
            fixed: expandedRowKeys.length > 0 ? null : 'left',
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
            fixed: expandedRowKeys.length > 0 ? null : 'left',
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 130,
        }, {
            title: '区域',
            dataIndex: 'workArea',
            key: 'workArea',
            width: 140,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
            width: 140,
        }, {
            title: '直线主管',
            dataIndex: 'leaderUser',
            key: 'leaderUser',
            width: 150,
        }, {
            title: '参与项目数量',
            dataIndex: 'investigationNum',
            key: 'investigationNum',
            width: 150,
        }, {
            title: '进行中项目数量',
            dataIndex: 'underwayInvestigationNum',
            key: 'underwayInvestigationNum',
            width: 150,
        }, {
            title: '累计FTE',
            dataIndex: 'totalFte',
            key: 'totalFte',
            sorter: true,
            width: 150,
        }, {
            title: '上月FTE',
            dataIndex: 'lastMonthFte',
            key: 'lastMonthFte',
            sorter: true,
            width: 150,
        }, {
            title: '当月FTE',
            dataIndex: 'currentMonthFte',
            key: 'currentMonthFte',
            sorter: true,
            width: 145,
        }];

        if (data.length > 0) {
            if (data[0].userPlans && data[0].userPlans.length > 0) {
                data[0].userPlans.map( (item, index) => {
                    columns.push({
                        title: `${item.year}.${item.month}`,
                        children: [{
                            title: '已分配',
                            dataIndex: 'planFte' + index,
                            key: 'planFte' + index,
                            width: 60,
                        }, {
                            title: '预分配',
                            dataIndex: 'prospectiveFte' + index,
                            key: 'prospectiveFte' + index,
                            width: 60,
                        }],
                    })
                })
            }
        }
        return columns;
    }

    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;

        if (data.length > 0) {
            data.map((item, index) => {
                const addData = {};
                if (item.userPlans && item.userPlans.length > 0) {
                    item.userPlans.map((planItem, planIndex) => {
                        addData['planFte' + planIndex] = planItem.planFte;
                        addData['prospectiveFte' + planIndex] = planItem.prospectiveFte;
                    })
                }
                dataSource.push({
                    key: index + 1,
                    ...item,
                    ...addData,
                });
            });
        }
        return dataSource;
    }

    search = params => {
        const { searchParams, pagination }  = this.state;
        pagination.current = 1;

        this.setState({
            searchParams: {
                ...searchParams,
                ...params,
            },
            pagination,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams, pagination = {} } = this.state;
        let url = API_URL.hospital.exportSsuMemberArrange;
        ExportUtil.export(searchParams, pagination, url);
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;

        if (sorter.field) {
            sortParams.sort = sorter.field;
        }
        if (sorter.order == 'descend') {
            sortParams.direction = 'DESC';
        } else if (sorter.order == 'ascend') {
            sortParams.direction = 'ASC';
        }
        this.setState({
            sortParams,
            pagination,
        }, () => {
            this.loadData();
        });
    }

    handleInvTableChange = (pagination, filters, sorter) => {
        const { invSortParams } = this.state;

        if (sorter.field) {
            invSortParams.sort = sorter.field;
        }
        if (sorter.order == 'descend') {
            invSortParams.direction = 'DESC';
        } else if (sorter.order == 'ascend') {
            invSortParams.direction = 'ASC';
        }
        this.setState({
            invSortParams,
        }, () => {
            this.loadInvData();
        });
    }

    getInvList = (key) => {
        let data = [];
        switch (key) {
            case 1:
                data = this.state.invList1;
                break;
            case 2:
                data = this.state.invList2;
                break;
            case 3:
                data = this.state.invList3;
                break;
        }
        return data;
    }

    onExpand = (expanded, record) => {
        const { invSearchParams, expandedRowKeys } = this.state;
        if (expandedRowKeys.length == 0) {
            expandedRowKeys.push(record.userId);
        } else {
            if (expanded) {
                expandedRowKeys.push(record.userId);
            } else {
                expandedRowKeys.map((item, index) => {
                    if (item == record.userId) {
                        expandedRowKeys.splice(index, 1);
                    };
                });
            }
        }
        this.setState({ expandedRowKeys });
        if (expanded) {
            invSearchParams.key = record.key;
            invSearchParams._userId = record.userId;
            this.setState({
                invSearchParams,
            }, () => {
                this.loadInvData();
            })
        }
    }

    expandedRowRender = (record) => {
        const { invLoading } = this.state;
        const invList = this.getInvList(record.key);

        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 100,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 120,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: 'JDE主项目号',
                dataIndex: 'jdeMainCode',
                key: 'jdeMainCode',
                width: 100,
            }, {
                title: '项目领域',
                dataIndex: 'areaName',
                key: 'areaName',
                width: 90,
            }, {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            }, {
                title: '项目阶段',
                dataIndex: 'stageName',
                key: 'stageName',
                width: 85,
            }, {
                title: '医院',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 90,
            }, {
                title: '科室',
                dataIndex: 'departmentLocalName',
                key: 'departmentLocalName',
                width: 80,
            }, {
                title: '区域',
                dataIndex: 'hospitalAreaName',
                key: 'hospitalAreaName',
                width: 80,
            }, {
                title: '城市',
                dataIndex: 'hospitalCity',
                key: 'hospitalCity',
                width: 70,
            }, {
                title: '中心启动时间',
                dataIndex: 'startTime',
                key: 'startTime',
                width: 90,
            }, {
                title: '累计FTE',
                dataIndex: 'totalFte',
                key: 'totalFte',
                sorter: true,
                width: 80,
            }, {
                title: '上月FTE',
                dataIndex: 'lastMonthFte',
                key: 'lastMonthFte',
                sorter: true,
                width: 80,
            }, {
                title: '当月FTE',
                dataIndex: 'currentMonthFte',
                key: 'currentMonthFte',
                sorter: true,
                width: 80,
            }];
            if (invList && invList.length > 0) {
                if (invList[0].userInvPlans && invList[0].userInvPlans.length > 0) {
                    invList[0].userInvPlans.map( (item, index) => {
                        columns.push({
                            title: `${item.year}.${item.month}`,
                            children: [{
                                title: '已分配',
                                dataIndex: 'planFte' + index,
                                key: 'planFte' + index,
                                width: 60,
                            }, {
                                title: '预分配',
                                dataIndex: 'prospectiveFte' + index,
                                key: 'prospectiveFte' + index,
                                width: 60,
                            }],
                        })
                    })
                }
            }
            return columns;
        }
    
        const getDataSource = () => {
            const dataSource = [];
    
            if (invList && invList.length > 0) {
                invList.map((item, index) => {
                    const addData = {};
                    if (item.userInvPlans && item.userInvPlans.length > 0) {
                        item.userInvPlans.map((planItem, planIndex) => {
                            addData['planFte' + planIndex] = planItem.planFte;
                            addData['prospectiveFte' + planIndex] = planItem.prospectiveFte;
                        })
                    }
                    dataSource.push({
                        index: index + 1,
                        ...item,
                        ...addData,
                    });
                });
            }
            return dataSource;
        };

        let x = 1460;
        if (invList && invList.length > 0) {
            if (invList[0].userInvPlans && invList[0].userInvPlans.length > 0) {
                x = 1460 + invList[0].userInvPlans.length * 2 * 60;
            }
        }
    
        return (
            <Table
                rowKey={record => record.index}
                onChange={this.handleInvTableChange}
                columns={getColumns()}
                dataSource={getDataSource()}
                loading={invLoading}
                pagination={false}
                scroll={{ x, y: 300 }}
            />
        );
    }
    
    render() {
        const { data, loading, pagination, expandedRowKeys } = this.state;
        let x = 1545;
        if (data && data.length > 0) {
            if (data[0].userPlans && data[0].userPlans.length > 0) {
                x = 1545 + data[0].userPlans.length * 2 * 60;
            }
        }
        return (
            <div className="content">
                <SideNav selectKey='staffing' />
                <div className="main">
                    <div className="main-content table-align-center">
                        <Filter search={this.search} export={this.export} />
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.userId}
                            loading={loading} 
                            scroll={{ x }}
                            onChange={this.handleTableChange}
                            pagination={pagination}
                            onExpand={this.onExpand}
                            expandedRowKeys={expandedRowKeys}
                            expandedRowRender={this.expandedRowRender}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Staffing;


// WEBPACK FOOTER //
// ./src/components/hospital/Staffing/index.js